import {detect} from "detect-browser"
import axios from "axios"

const testEnv = process.env.NODE_ENV === 'test'

export default function logErrorToSlack(error, additionalData) {

    if (!testEnv) {
        console.error(error)
        console.error(additionalData)
    }


    let errorToLog = null

    if (error instanceof Error)
        errorToLog = error.toString()
    else
        errorToLog = JSON.stringify(error, null, 2)

    const browser = testEnv  ?   null :detect()

    axios.post('https://hooks.slack.com/services/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',

        JSON.stringify({
            text: JSON.stringify({
                location:  testEnv ?  'test' :   window.location.href ,
                browser: {
                    name: !!browser ? browser.name : 'nao detectado',
                    version: !!browser ? browser.version : 'nao detectado',
                    os: !!browser ? browser.os : 'nao detectado',

                },
                error: errorToLog,
                data: additionalData
            }, null, 2)
        }, null, 2),
        {
            withCredentials: false,
            transformRequest: [(data, headers) => {
                delete headers.post["Content-Type"]
                return data
            }]
        })
        .then(res => {
            if (!testEnv)
                console.log(res)
        })
}


// WEBPACK FOOTER //
// ./src/_functions/log-error-to-slack.js